/* global axios */
import ApiClient from '../ApiClient';

// Team presence board and summons (owner order 2026-09-26).
class TeletelTeamPresenceAPI extends ApiClient {
  constructor() {
    super('teletel/team_presence', { accountScoped: true });
  }

  list() {
    return axios.get(this.url);
  }

  summon({ userIds, note, escalateToId, escalateAfterMinutes }) {
    return axios.post(`${this.url}/summons`, {
      user_ids: userIds,
      note,
      escalate_to_id: escalateToId,
      escalate_after_minutes: escalateAfterMinutes,
    });
  }

  updateWindow(seconds) {
    return axios.patch(`${this.url}/window`, { seconds });
  }

  acknowledge(summonId) {
    return axios.post(`${this.url}/summons/${summonId}/acknowledge`);
  }
}

export default new TeletelTeamPresenceAPI();
